import typeof Extension from './extension';

const extensionsStorage: Map<string, Extension> = new Map();

export default extensionsStorage;
